import { BetSlipType } from '@bpos';

import { BetslipType } from '../../../core/betslip-type';
import { ISucceededSlipResult } from '../../betplacement/models';
import { RewardTokenContext } from '../../reward-tokens/reward-tokens.model';

export function mapBetslipType(betslipType: BetSlipType | undefined): BetslipType | undefined {
    switch (betslipType) {
        case BetSlipType.Single:
            return BetslipType.Single;

        case BetSlipType.Combo:
            return BetslipType.Combo;

        case BetSlipType.System:
            return BetslipType.System;

        default:
            return undefined;
    }
}

export function getSucceedSlipTokensContext(succeededSlip: ISucceededSlipResult): RewardTokenContext | null {
    const mappedType = mapBetslipType(succeededSlip.betType);

    switch (mappedType) {
        case BetslipType.Combo:
            return { betslipType: BetslipType.Combo };

        case BetslipType.Teaser:
            return { betslipType: BetslipType.Teaser };

        case BetslipType.Single:
            const picks = succeededSlip.picks;

            if (picks.length !== 1) {
                return null;
            }

            const pick = picks[0];

            return { betslipType: BetslipType.Single, pickId: pick.pickId };

        default:
            return null;
    }
}
